import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { NgStyle } from '@angular/common';

@Component({
  selector: 'bevvi-bot-typing-loader',
  imports: [NgStyle],
  templateUrl: './bot-typing-loader.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BotTypingLoader {
  public readonly dotColor = input('#B63333');
  public readonly dotSize = input(10);
  public readonly gap = input(8);
  public readonly duration = input(1000);

  protected readonly loaderStyles = computed(() => ({
    '--dot-color': this.dotColor(),
    '--dot-size': `${this.dotSize()}px`,
    '--dot-gap': `${this.gap()}px`,
    '--animation-duration': `${this.duration()}ms`,
  }));
}
